module.exports = __webpack_public_path__ + "components/media-kit/static/media-kit-background-f17a5b75f24e3393ef1f4c886d2856e4.jpg";